import React from 'react';

import 'react-app-polyfill/ie11';
import 'core-js/features/array/find';
import 'core-js/features/array/values';

import './styles/styles.scss';
import MainLayout from './components/MainLayout/MainLayout';

/**
 * Root component
 */
function App() {
  return (
    <MainLayout/>
  );
}

export default App;
